import { defineMessages } from 'react-intl';

export default defineMessages({
  save: {
    id: 'court_manager_legal_proceedings_page.drawers.save_button.title',
  },
  documents: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.documents',
  },
});
